import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-test", "disabled"]
const _hoisted_2 = ["data-test"]
const _hoisted_3 = ["data-test"]

import ImageIcon from 'frontcore/views/icons/image-icon/ImageIcon.vue'
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { ChipType } from 'frontcore/views/chips/chip/types'
import { computed } from 'vue'

type Props = {
  chipType: ChipType
  dataTest?: string
  deletable?: boolean
  disabled?: boolean
  iconName?: string
  imageSrc?: string
  label: string
  open?: boolean
  selected?: boolean
}

type Emits = {
  (e: 'click', event: Event): void
  (e: 'handlerClick', event: Event): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCoreChip',
  props: {
    chipType: {},
    dataTest: { default: 'core-chip' },
    deletable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    iconName: {},
    imageSrc: {},
    label: {},
    open: { type: Boolean, default: false },
    selected: { type: Boolean, default: false }
  },
  emits: ["click", "handlerClick"],
  setup(__props: any, { emit: __emit }) {

const props =  __props

const emit = __emit

const chipHTMLClass = computed<Record<string, boolean>>(() => {
  return {
    'core-chip': true,
    'core-chip--disabled': props.disabled,
    'core-chip--selected': props.selected,
    'core-chip__border': true,
    'pointer': !props.disabled,
  }
})

const imageIconDataTest = computed((): string => `${props.dataTest}-image-icon`)

const leftIconDataTest = computed((): string => `${props.dataTest}-icon`)
const leftIconName = computed((): string | undefined => {
  switch (props.chipType) {
  case ChipType.ACTION:
  case ChipType.INPUT:
    return props.iconName
  case ChipType.FILTER:
  case ChipType.DROPDOWN:
    return props.selected ? 'Check' : props.iconName
  }
})

const labelDataTest = computed((): string => `${props.dataTest}-label`)

const handlerDataTest = computed((): string => `${props.dataTest}-handler`)
const handlerIconName = computed((): string | undefined => {
  switch (props.chipType) {
  case ChipType.ACTION:
  case ChipType.FILTER:
    return
  case ChipType.INPUT:
    return props.deletable ? 'Close' : undefined
  case ChipType.DROPDOWN:
    return props.open ? 'ArrowDropUp' : 'ArrowDropDown'
  }
})

const onClickChip = (event: Event) => {
  if (props.disabled) { return }
  emit('click', event)
}

const onClickHandler = (event: Event) => {
  if (props.disabled) { return }
  emit('handlerClick', event)
}

const chipHandlerColorClass = computed(() => {
  const defaultColor = props.selected ? 'tw-fill-core-primary-30' : 'tw-fill-core-neutral-cold-30'
  return props.disabled ? 'tw-fill-core-neutral-cold-80' : defaultColor
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(chipHTMLClass.value),
    "data-test": _ctx.dataTest,
    disabled: _ctx.disabled,
    onClick: onClickChip
  }, [
    (leftIconName.value)
      ? (_openBlock(), _createBlock(SVGIcon, {
          key: 0,
          "data-test": leftIconDataTest.value,
          iconName: leftIconName.value,
          remSize: 1.25,
          class: "core-chip__li core-chip__icon"
        }, null, 8, ["data-test", "iconName"]))
      : (_ctx.imageSrc)
        ? (_openBlock(), _createBlock(ImageIcon, {
            key: 1,
            "data-test": imageIconDataTest.value,
            imageSrc: _ctx.imageSrc,
            class: "core-chip__li core-chip__icon"
          }, null, 8, ["data-test", "imageSrc"]))
        : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "core-chip__li core-chip__label buttons--button-01",
      "data-test": labelDataTest.value
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    (handlerIconName.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          "data-test": handlerDataTest.value,
          class: "core-chip__li core-chip__handler",
          onClick: _withModifiers(onClickHandler, ["stop"])
        }, [
          _createVNode(SVGIcon, {
            colorClass: chipHandlerColorClass.value,
            iconName: handlerIconName.value,
            remSize: 1.25
          }, null, 8, ["colorClass", "iconName"])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})